import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import { PlayIcon, PauseIcon } from 'helpers/svgs';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			bgVideoPlaying: true
		};
		this.toggleBgVideo = this.toggleBgVideo.bind(this);
	}

	toggleBgVideo() {
		const { bgVideoPlaying } = this.state;
		if (bgVideoPlaying) {
			Store.emit('SIMPLE_PAUSE_BACKGROUND_VIDEO');
		} else {
			Store.emit('SIMPLE_PLAY_BACKGROUND_VIDEO');
			// include this one so that in low power mode and vid is hidden, it reveals the vid
			Store.emit('PLAY_BACKGROUND_VIDEO');
		}

		this.setState({ bgVideoPlaying: !bgVideoPlaying });
		Store.emit('HEADER_BG_VIDEO_PAUSED', bgVideoPlaying);
	}

	renderExtraActions() {
		const { bgVideoPlaying } = this.state;
		return (
			<button class={s.bgVidToggle} onClick={this.toggleBgVideo}>
				<PlayIcon class={joinClasses(s.playIcon, bgVideoPlaying && s.hide)} />
				<PauseIcon class={joinClasses(s.pauseIcon, !bgVideoPlaying && s.hide)} />
			</button>
		);
	}

}
